module.exports = __webpack_public_path__ + "img/cha.3906564c.png";